"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var enums_1 = require("../../enums");
var Table_style_1 = require("./Table.style");
var CheckboxField_1 = require("../CheckboxField");
var TableRow_1 = require("./TableRow/TableRow");
var react_infinite_scroll_component_1 = tslib_1.__importDefault(require("react-infinite-scroll-component"));
var TypographyColor_1 = require("../../enums/TypographyColor");
var Spinner_1 = require("./Spinner/Spinner");
var TableHelper_1 = require("./TableHelper");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var Table = function (_a) {
    var columns = _a.columns, rows = _a.rows, selectable = _a.selectable, onSelect = _a.onSelect, allSelected = _a.allSelected, _b = _a.hasInfiniteScrollableContentLoading, hasInfiniteScrollableContentLoading = _b === void 0 ? false : _b, _c = _a.initialNumberOfRowsToShow, initialNumberOfRowsToShow = _c === void 0 ? 0 : _c, totalNumberOfRows = _a.totalNumberOfRows, loadingMessage = _a.loadingMessage, endOfScrollableContentMessage = _a.endOfScrollableContentMessage, onFieldChange = _a.onFieldChange, onGetMoreRows = _a.onGetMoreRows, name = _a.name, _d = _a.isDraggable, isDraggable = _d === void 0 ? false : _d, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, _e = _a.draggableColumnHeader, draggableColumnHeader = _e === void 0 ? 'Order' : _e, _f = _a.isIndexed, isIndexed = _f === void 0 ? true : _f;
    var classes = (0, Table_style_1.useTableStyles)();
    var hasInfiniteScrolling = (0, TableHelper_1.shouldHaveInfiniteScrolling)(hasInfiniteScrollableContentLoading, initialNumberOfRowsToShow, rows.length, totalNumberOfRows);
    var scrollableContentHeight = (0, TableHelper_1.calculateScrollableContentHeight)(initialNumberOfRowsToShow);
    var _g = (0, react_1.useState)(hasInfiniteScrolling), hasMoreScrollableContent = _g[0], setHasMoreScrollableContent = _g[1];
    var calculateColumnSizes = function () {
        return columns.map(function (column) { return column.size; });
    };
    var _h = (0, react_1.useState)(calculateColumnSizes()), columnSizes = _h[0], setColumnSizes = _h[1];
    var generateEditableFields = function () {
        return rows.map(function (row) { return ({
            id: row.id,
            data: row.data.map(function (data) { return ({
                id: data.id,
                isEditing: false,
            }); }),
        }); });
    };
    var _j = (0, react_1.useState)(generateEditableFields()), editableRows = _j[0], setEditableRows = _j[1];
    (0, react_1.useEffect)(function () {
        setEditableRows(generateEditableFields());
    }, [rows.length]);
    var getErrorCells = function (rows) {
        return rows.flatMap(function (row) {
            return row.data
                .filter(function (cell) { var _a; return (_a = cell.validation) === null || _a === void 0 ? void 0 : _a.isError; })
                .map(function (cell) { return ({ errorRow: row.id, errorField: cell.id }); });
        });
    };
    var setFieldAsEditable = function (rowId, fieldId, isEditing, isBlur) {
        if (isBlur === void 0) { isBlur = false; }
        var errorCells = getErrorCells(rows);
        var hasError = function (rowId, fieldId) {
            return errorCells.some(function (cell) { return cell.errorRow === rowId && cell.errorField === fieldId; });
        };
        setEditableRows(function (prev) {
            return prev.map(function (row) { return ({
                id: row.id,
                data: row.data.map(function (data) {
                    var isSameRow = row.id === rowId && data.id === fieldId;
                    return {
                        id: data.id,
                        isEditing: isSameRow && !isBlur ? isEditing : hasError(row.id, data.id),
                    };
                }),
            }); });
        });
    };
    var onScrollBottomHandler = function () {
        if (onGetMoreRows) {
            onGetMoreRows();
        }
    };
    var onChangeHandler = function (event) {
        if (onSelect) {
            onSelect(event, TableHelper_1.ALL_ID);
        }
    };
    var onDragEndHandler = function (result) {
        if (onDragEnd) {
            onDragEnd(result);
        }
    };
    var onDragStartHandler = function (initial) {
        if (onDragStart) {
            onDragStart(initial);
        }
    };
    (0, react_1.useEffect)(function () {
        setColumnSizes(calculateColumnSizes());
    }, [columns]);
    (0, react_1.useEffect)(function () {
        if (totalNumberOfRows && rows.length >= totalNumberOfRows) {
            setHasMoreScrollableContent(false);
        }
        else {
            setHasMoreScrollableContent(true);
        }
    }, [rows.length]);
    var loaderProps = loadingMessage
        ? {
            content: loadingMessage,
        }
        : {};
    var Loader = function () { return react_1.default.createElement(Spinner_1.Spinner, tslib_1.__assign({}, loaderProps, { "data-signa": "scrollable-content-loader" })); };
    var EndOfScrollableContent = function () { return (react_1.default.createElement(core_1.Typography, { color: TypographyColor_1.TypographyColor.primary, variant: "body2", className: classes.scrollEndedMessage, "data-signa": "end-of-scrollable-content" }, endOfScrollableContentMessage)); };
    var getRows = function () {
        return rows.map(function (row, index) {
            return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { key: row.id, draggableId: row.id, index: index, isDragDisabled: !(row === null || row === void 0 ? void 0 : row.isDraggable) }, function (provided) { return (react_1.default.createElement(TableRow_1.TableRow, { columnSizes: columnSizes, row: row, setFieldAsEditable: setFieldAsEditable, editableRows: editableRows, onFieldChange: onFieldChange, selectable: selectable || false, onSelect: onSelect, isDraggable: isDraggable, rowIndex: index, provided: provided, isIndexed: isIndexed })); }));
        });
    };
    var getTable = function () {
        return (react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEndHandler, onDragStart: onDragStartHandler },
            react_1.default.createElement("table", { className: classes.container, "data-signa": "table-".concat(name) },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", { className: classes.headers },
                        selectable && (react_1.default.createElement("th", null,
                            react_1.default.createElement(CheckboxField_1.CheckboxField, { customClasses: { formControlLabel: classes.checkbox }, size: enums_1.Size.small, name: 'select-all', checked: allSelected || false, onChange: onChangeHandler }))),
                        isDraggable ||
                            (isIndexed && (react_1.default.createElement("th", { className: classes.draggableHeaderContainer },
                                react_1.default.createElement(core_1.Typography, { component: "div", color: TypographyColor_1.TypographyColor.textPrimary, variant: "caption", className: classes.header }, draggableColumnHeader)))),
                        columns.map(function (column) {
                            var columnStyles = column.size ? { width: column.size } : {};
                            return (react_1.default.createElement("th", { key: column.label, style: columnStyles },
                                react_1.default.createElement(core_1.Typography, { key: column.label, component: "div", color: TypographyColor_1.TypographyColor.textPrimary, variant: "caption", className: classes.header }, column.label)));
                        }))),
                react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "signers", direction: "vertical" }, function (provided) { return (react_1.default.createElement("tbody", tslib_1.__assign({ ref: provided.innerRef }, provided.droppableProps),
                    getRows(),
                    provided.placeholder)); }))));
    };
    return (react_1.default.createElement(react_infinite_scroll_component_1.default, { dataLength: rows.length, next: onScrollBottomHandler, hasMore: hasMoreScrollableContent, height: hasInfiniteScrolling ? scrollableContentHeight : TableHelper_1.FULL_HEIGHT, loader: hasInfiniteScrolling && react_1.default.createElement(Loader, null), endMessage: hasInfiniteScrolling && endOfScrollableContentMessage && react_1.default.createElement(EndOfScrollableContent, null), style: { overflow: hasInfiniteScrolling ? 'auto' : 'visible' } }, getTable()));
};
exports.Table = Table;
